
import axios from 'axios';

function buildFormData(formData, data, parentKey) {
  if (data && typeof data === 'object' && !(data instanceof Date) && !(data instanceof File)) {
    Object.keys(data).forEach((key) => {
      buildFormData(formData, data[key], parentKey ? `${parentKey}[${key}]` : key);
    });
  } else {
    const value = data == null ? '' : data;

    formData.append(parentKey, value);
  }
}

function jsonToFormData(data) {
  const formData = new FormData();

  buildFormData(formData, data);

  return formData;
}

const HTTP = axios.create({
  baseURL: process.env.VUE_APP_API_URL,
  withCredentials: true,
  // timeout: 10 * 1000,
  headers: {
    'Content-Type': 'application/json',
  },
});

export { HTTP, jsonToFormData };
